module.exports = __webpack_public_path__ + "img/35.0edb7397.jpg";